/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_RecommendedInputs */

const en_us2_plan_build_recommended = /** @type {(inputs: Plan_Build_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended for you`)
};

const pt_br2_plan_build_recommended = /** @type {(inputs: Plan_Build_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendados para você`)
};

const es_419_plan_build_recommended = /** @type {(inputs: Plan_Build_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendados para ti`)
};

const pt_pt2_plan_build_recommended = /** @type {(inputs: Plan_Build_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendados para ti`)
};

const fr_fr2_plan_build_recommended = /** @type {(inputs: Plan_Build_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommandés pour toi`)
};

const de_de2_plan_build_recommended = /** @type {(inputs: Plan_Build_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dich empfohlen`)
};

const it_it2_plan_build_recommended = /** @type {(inputs: Plan_Build_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigliati per te`)
};

/**
* | output |
* | --- |
* | "Recommended for you" |
*
* @param {Plan_Build_RecommendedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_recommended = /** @type {((inputs?: Plan_Build_RecommendedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_RecommendedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_recommended(inputs)
	if (locale === "es-419") return es_419_plan_build_recommended(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_recommended(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_recommended(inputs)
	if (locale === "de-DE") return de_de2_plan_build_recommended(inputs)
	if (locale === "it-IT") return it_it2_plan_build_recommended(inputs)
	return en_us2_plan_build_recommended(inputs)
});
export { plan_build_recommended as "plan-build.recommended" }